import { GETALLPOLICY_SUCCESS, GETALLPOLICY_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getAllPolicyReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETALLPOLICY_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETALLPOLICY_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default getAllPolicyReducer;
